"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationStyles = exports.useNotificationMenuStyles = exports.useNotificationButtonStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useNotificationButtonStyles = (0, makeStyles_1.default)(() => ({
    notificationIcon: {
        color: 'white',
        width: '20px',
        height: '20px',
        padding: 0,
        margin: 0,
    },
    button: {
        height: 33,
        minWidth: 40,
        paddingLeft: 0,
        paddingRight: 0,
    },
}));
exports.useNotificationMenuStyles = (0, makeStyles_1.default)((theme) => ({
    header: {
        padding: '10px 16px',
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: `${theme.palette.primary.main}33`,
    },
    menu: {
        height: 'fit-content',
        width: 500,
        overflow: 'hidden',
    },
    loaderWrapper: {
        width: '100%',
        height: 'calc(100% - 50px)',
        position: 'absolute',
        backgroundColor: '#e1e2e340',
        zIndex: 1000,
    },
    loader: {
        position: 'absolute',
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 20px)',
    },
    icons: {
        display: 'flex',
        gap: '15px',
    },
    icon: {
        '& svg': {
            width: 20,
            height: 20,
        },
    },
}));
exports.useNotificationStyles = (0, makeStyles_1.default)(() => ({
    notification: {
        cursor: 'default',
        width: '100%',
        height: '100%',
        whiteSpace: 'normal',
        boxShadow: '0 0 0',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    notificationContent: {
        whiteSpace: 'pre-wrap',
    },
    notificationSubheader: {
        fontSize: 11,
        fontWeight: 500,
    },
    notificationTitle: {
        fontSize: 14,
        fontWeight: 400,
    },
    notificationActionButton: {
        alignSelf: 'auto',
        marginRight: 0,
    },
}));
//# sourceMappingURL=notification-styles.js.map